//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  async asyncData ({ store, $sentry, res }) {
    try {
      const athletes = await store.dispatch('proteam/GET_ATHLETES')
      return { athletes }
    } catch (e) {
      $sentry.captureException(e)
      if (process.server) res.statusCode = 503
      throw new Error('Unable to load athletes')
    }
  },
  data () {
    return {
      noDynamicPhoto: ['hannah-whiteley', 'tom-bishop']
    }
  },
  head () {
    return {
      title: this.getTitle('SunGod Pro Team'),
      meta: [
        ...this.getDescription('Continually inspiring us to raise the bar, the SunGod Pro Team perform at the highest level in their individual sports. They test our products to the limit…'),
        { hid: 'og:title', property: 'og:title', content: this.getTitle('SunGod Pro Team') }
      ]
    }
  }
}
